import styled from 'styled-components'
import { Button } from '@navent-jobs/ui-kit/components/button'
import { Row } from '@navent-jobs/ui-kit/components/grid'

export const Divider = styled.div`
  border-top: 1px solid ${({ theme }) => theme.colors.grey24};
  margin: 32px 0;
`

export const FooterContent = styled.div`
  display: flex;
  flex-direction: column-reverse;
  justify-content: center;
  align-items: center;
  padding: 0 4px;
  gap: 8px;

  @media (min-width: ${({ theme }) => theme.screen.smMin}) {
    flex-direction: row;
    gap: 24px;
  }
`

export const CustomButton = styled(Button)`
  width: 100%;

  @media (min-width: ${({ theme }) => theme.screen.smMin}) {
    max-width: 200px;
  }
`

export const Title = styled.div`
  text-align: center;
  margin: 20px 0;

  @media (min-width: ${({ theme }) => theme.screen.smMin}) {
    margin: 0;
  }
`

export const Amounts = styled.div`
  margin: 0;
  text-align: right;
`

export const DataContainer = styled.div`
  width: 100%;

  @media (min-width: ${({ theme }) => theme.screen.smMin}) {
    max-width: 436px;
  }
`

export const ModalContainer = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  margin-bottom: 25px;

  @media (min-width: ${({ theme }) => theme.screen.smMin}) {
    margin-bottom: 32px;
  }
`

export const CustomImage = styled.img`
  margin-bottom: 25px;

  @media (min-width: ${({ theme }) => theme.screen.smMin}) {
    margin-bottom: 32px;
  }
`

export const CustomRow = styled(Row)`
  margin-bottom: 16px;
`
